import type { MenuItemProps as MuiMenuItemProps } from "@mui/material/MenuItem";
import MuiMenuItem from "@mui/material/MenuItem";
import { Typography } from "../../General";

export interface SelectItemProps
    extends Pick<MuiMenuItemProps, "disabled" | "onClick" | "selected"> {
    value: string;
    children: string;
}

export function SelectItem({
    disabled,
    children,
    onClick,
    selected,
    value,
    ...props
}: SelectItemProps) {
    return (
        <MuiMenuItem
            disabled={disabled}
            onClick={onClick}
            selected={selected}
            value={value}
            {...props}
        >
            <Typography>{children}</Typography>
        </MuiMenuItem>
    );
}
